import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid2,
  Typography,
  Stack,
  useTheme,
  Box,
} from "@mui/material";
import { useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";
import { Url } from "../../Api/Api";
import axios from "axios";
import { getAccessToken, getUserId } from "../../hooks/useLocalStorage";
import ProfileForgotPassword from "../../ProfilePasswordChange.js/ProfileForgotPassword";
import { AccountSettingsFields } from "../../components/adminComponents/AccountSettings";

export default function AccountIndex() {
  const theme = useTheme();
  const { drawerOpen } = useOutletContext();
  const drawerWidth = 10;
  const collapsedWidth = 240;

  const [formValues, setFormValues] = useState({
    oldPassword: {
      value: "",
      showPassword: false,
      error: false,
      errorMessage: "",
    },
    newPassword: {
      value: "",
      showPassword: false,
      error: false,
      errorMessage: "",
    },
  });

  const token = getAccessToken();

  const [superAdminDetails, setSuperAdminDetails] = useState(null);

  const getAdminDetails = async () => {
    try {
      const response = await axios.get(Url.GetSuperAdminDetails, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSuperAdminDetails(response?.data);
    } catch (e) {
      console.log("error", e);
    }
  };

  useEffect(() => {
    getAdminDetails();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: 2,
          transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          marginLeft: `${drawerOpen ? drawerWidth : collapsedWidth}px`,
          ...(!drawerOpen && {
            transition: theme.transitions.create("margin", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            sx={{
              background:
                theme.palette.mode === "light"
                  ? "linear-gradient(to right, #00bfff, #00bfff)"
                  : "linear-gradient(to right, #00bfff, #00bfff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            Account Settings
          </Typography>
          <Typography variant="body1" color="#002147">
            View and edit your Account
          </Typography>
        </Box>
        <Grid2 container justifyContent="center">
          <Card
            sx={{
              borderRadius: 3,
              p: 4,
              width: 900,
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              background: "#F3F5F7",
            }}
          >
            <Typography pl={5} variant="h5" color="black" fontWeight={700}>
              Account Settings
            </Typography>
            <Typography pl={5} variant="caption" color="text.secondary" mb={4}>
              Edit your name, password etc.
            </Typography>

            <CardContent sx={{ p: 5 }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                width="100%"
              >
                <Box flex={1}>
                  <AccountSettingsFields
                    label="First Name"
                    value={superAdminDetails?.firstName}
                    disabled
                  />
                </Box>

                <Box flex={1}>
                  <AccountSettingsFields
                    label="Last Name"
                    value={superAdminDetails?.lastName}
                    disabled
                  />
                </Box>
              </Stack>
              <Box mb={3} mt={2}>
                <AccountSettingsFields
                  label="Email Address"
                  value={superAdminDetails?.emailId}
                  disabled
                />
              </Box>
              <ProfileForgotPassword email={superAdminDetails?.emailId} />
            </CardContent>
          </Card>
        </Grid2>
      </Box>
    </Box>
  );
}
